import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d8a5eb8&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/tickets/_tickets.scss?vue&type=style&index=0&id=4d8a5eb8&prod&scoped=true&lang=scss&"
import style1 from "@/assets/scss/mobile/tutorial/tutorial.scss?vue&type=style&index=1&id=4d8a5eb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8a5eb8",
  null
  
)

export default component.exports